module.exports = __webpack_public_path__ + "img/ding_qr.a8a6f9e6.png";